import Vue from 'vue'
import Vuex from 'vuex'
// eslint-disable-next-line import/no-cycle
import global from './modules/global'
import rentPlan from './modules/rentPlan' // 租赁设置
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import carResource from './modules/carResource'
// hubble
// import hubble from './modules/hubble'
import company from './modules/getCompany'
// 审批approve
import approve from './modules/approve'
// activeBuild
import getters from './getters'
// 司机
import customer from './modules/customer'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    global,
    app,
    user,
    permission,
    // hubble,
    company,
    approve,
    rentPlan,
    carResource,
    customer,
  },
  getters,
})

export default store
